export class DependenteADO {
    iD_PESSOA: number;
    iD_PESSOA_DEP: number;
    iD_PARENTESCO: number;
    iC_INVALIDO: string;
    iC_SUPERIOR: string;
}